var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "64px",
    viewBox: "0 0 72 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "card_icone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components-layer-copy",
    transform: "translate(-434.000000, -434.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "card_icone",
    x: 434,
    y: 434,
    width: 72,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABACAYAAAC5vjEqAAAABGdBTUEAALGOfPtRkwAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAASKADAAQAAAABAAAAQAAAAACgQQ0uAAAEcUlEQVR4Ae2c32scRRzA5zu7+SFWbBtftKS0L0lNQlLQPAgGUkSCD32116pBKP1hH6oWSouiXlAUI/hufUtIvOI/INKWlD6lT41JaC5QAi22T6Gmbczd5Wa/fmdzuz1xk9mdJfZubuZhdzLz/c7O97PfnZ2b+WaBUcLhvj1esfA95QaRsT2yrN4TMPYnYzDFW1ovwNgM5fUS+HBKhRlEbNNrora1AGCZN7f26UJyvdLaD4isjQH85jS7p2Bs/m5tmxyvdzjcvVcUy5foxg95pcIoab0XT/PfUpzccFAWOazppClwpD3SFgeaTsg8pUH/qHHgRPhlqQe5uXsa+jWtEthENr6i21HyIJu2ImABbUWH6tygXmQ6vgryJp3pBZQqhYCooWyqlgxVDgEBmAko7Y0PATm5xRETnaB8pCPVk2EHaYVXWEAWkIKAotp6kAWkIKCoth6kABS+5u1MOppUCCjthCq6+fovDQHZmXT0zQwB2Zl0NCA7SEdzCUstoBBFdCZ8xKKr678UgKf6EW48ICe3kE1zm+0jpqCXyoMaYUcWaEHJX7V1Ly/Sbm381Cg7stoe1Cg7sinGoMbYkdUG1Cg7stqA4o9W9S1pASnunwWkAORSgNF9Gf2AmZ72IBpCoVMX1Xi8e7f3pPwFAnsTkHXSXGYBONzg0PQNTM4+jGsEeRBel8KCrV+SQUdxFWtZDjNdA95qeQ4ZfsIQX6fzC2RnP3reOU8UZ/HogTfi9j9RCB4w+Mm5nD8tG9edYMbtmK4cfnhwp1dYm/djgmTUnINfshZYYH87XYKVv2bI3qbFwXvc2dUDE9OPNrtOaJ+M3aNZcZ8pQZwE5/MKnN/dXP6dKgDTVD4kMgeu0vmQJx5epLrPquojs/5MuhLg+H6kRJ0V0uM0ILvsOPw/4Tw03iIeezUrhDiEDHw5lXnGvcUAocs3+kU+F2n8cxvlNHBvyEUKPS00DhADtuSbtyL2PzWzKrdWKQ/kqqqisuYBQnZTGuoJ/DjKYE94ZyvlvlyUTHWZcYB4M/uWxppVGoiPi6Odo/hB7/PSYDzTvYMG6B9pPjRMb+PHnDV9Vw1is7xxgGA8v0QD9UcEoYQenqcg8hWR6Vzyltf/QvQ+pUWvIjr8ZNxJsXGApCe4ucVxzlk//ffANfqzRN60jyLBi5S/wrn7mjt5O0f5WEl7wSxW689QCH7J/0GXfwuzgy6786CdHe69C+/+KpJ2yVhAAQjITpUpv8TG80FRorORj1giAgphC8gCUhBQVFsPUgDalkF6q2i1zcJskugkkQ3s19GRutsCSBGtNhJ0uvqcRCeJbHANHR2puy2AdKLVkugkkQ0A6ehIXZp566VwxS3hlrXe1f5/rcA+O0gr2FtAFpCCgKLaepAFpCCgqNb2ILkjK9uWO7KKa9RddWCTtFEbEFk9JS0XuP6zKTuy0h7/kxZkk8xTmtKeB1VC8G7Rat1LG22ZdSTv8T+Kou1BcrORlPto7XeCKGt/fqbWsEpbpE3BF2P+AXLqvujAHiWLAAAAAElFTkSuQmCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedCreditCard);
export default __webpack_public_path__ + "static/media/saved_credit_card.55675b567a302e4e7a60f66331f8a64d.svg";
export { ForwardRef as ReactComponent };